 <template>
  <div class="result-view">
    <section class="section section--booking-engine">
      <booking-engine @search="e => search(e)"/>
    </section>
    <b-container>
      <section class="section section--loader" v-if="searching || appending">
        <loader size="large" :show_timing_slot="true" />
      </section>
      <section class="section filters" v-else>
        <b-row>
          <b-col cols="3" class="filters__sticky-wrapper" :class="{ visible: show_filters }">
            <div class="filters__content-wrapper">
              <!-- filter resume -->
              <div class="filters__head" v-if="filtered.results !== undefined">
                <p class="filters__head-element" v-if="!searching && !appending && total_properties">
                  <span class="filters__head-title">Abbiamo trovato {{ total_properties }} proposte</span>
                  <span v-if="!(searching | appending)" class="filters__head-link toggle-map">
                    <span @click="toggle_map()">
                      <span v-if="map" v-html="'(vedi su lista)'" />
                      <span v-if="!map" v-html="'(vedi su mappa)'" />
                    </span>
                  </span>
                </p>
                <!--<p class="filters__head-element" v-if="!searching && !appending">-->
                  <!--<span v-if="total_properties" class="filters__head-subtitle">su {{ total_properties }} totali</span>-->
                  <!--span v-if="searching | appending"><loader /></span>
                  <span
                    v-else-if="offset>-1" class="filters__head-link toggle-map" v-html="'(mostra altri)'"
                    @click="search()"
                  /-->
                <!--</p>-->
              </div>

              <div class="filters__wrap" :key="update_key_filter">
                
                <!-- refundable -->
                <div v-if="filtered.refundable" :set-total="total = filtered.refundable.length" class="filters__refundable mb-4">
                  <vb-checkbox
                    v-if="total"
                    @change="update_filter_refundable"
                    v-model="filter_refundable"
                    :vb_options="{
                      //text: 'Solo rimborsabili (' + total + ')',
                      text: `Solo rimborsabili ${total == this.hotels.length ? '' : '('+total+')'}`,
                      value: filter_refundable,
                      type: 'light',
                      switch: true,
                    }"/>
                </div>

                <!-- active filters -->
                <div class="filters__selected" v-if="active_filters().page_filters.length | active_filters().advanced_filters.length">
                  <p class="filters__section__title d-flex align-items-center justify-content-between">
                    <span>Filtri attivi:</span>
                    <span @click="() => {
                      reset_all_filters()
                    }" class="text--sm text-info underline cursor-pointer">cancella filtri</span>
                  </p>
                  <div class="d-flex flex-wrap mt-2">
                    <!-- active page filters -->
                    <b-badge pill variant="primary" class="semibold d-inline-flex mr-1 cursor-pointer mb-1"
                      v-for="(filter, index) in active_filters().page_filters"
                      v-bind:key="_uid+index+'-page-active'"
                      @click="() => {
                        let payload
                        switch (filter.key) {
                          case 'refundable':
                            payload = !filter_refundable
                            break
                          case 'price_range':
                          case 'stars':
                          case 'amenities':
                          case 'rate_amenities':
                          case 'salabam_scores':
                            payload = {
                              ...filter.filter,
                              selected: !filter.filter.selected,
                            }
                            break
                        }
                        filter.callback(payload)
                      }">
                      <div v-html="filter.text" />
                      <div class="ml-2">&#10005;</div>
                    </b-badge>
                    <!--active advanced filters-->
                    <b-badge pill variant="primary" class="semibold d-inline-flex mr-1 cursor-pointer mb-1"
                      v-for="(filter, index) in active_filters().advanced_filters"
                      v-bind:key="_uid+index+'-advanced-active'"
                      @click="() => {
                        filter.callback()
                      }">
                      <div v-html="filter.text" />
                      <div class="ml-2">&#10005;</div>
                    </b-badge>
                  </div>
                </div>

                <div class="filters__panel-wrap">

                  <!-- advanced filter: salabam category -->
                  <div class="filters__panel">
                    <b-row>
                      <b-col>
                        <div class="filters__hotel-categories">
                          <div class="filters__hotel-categories__item"
                            v-for="(category,index) in Object.keys(hotel_categories)"
                            v-bind:key="_uid+index+'_type'"
                            :class="{ active: advanced_filters.filter_hotel_categories.includes(index+1) }"
                            @click.stop="() => {
                              if(advanced_filters.filter_hotel_categories.includes(index+1)) {
                                advanced_filters.filter_hotel_categories = advanced_filters.filter_hotel_categories.filter(c => { return c!==index+1 })
                              }
                              else advanced_filters.filter_hotel_categories.push(index+1)
                              submit_advanced_filters()
                            }">
                              <vb-icon
                                class="filters__hotel-categories__icon"
                                :name="hotel_categories[category].icon"
                                :size="16"
                                :color="sass('primary')"
                              />
                              <div class="filters__hotel-categories__name">{{ hotel_categories[category].name }}</div>
                          </div>
                        </div>
                      </b-col>
                    </b-row>
                  </div>

                  <!-- filtri classici -->
                  <div class="filters__panel">

                    <!-- price range -->
                    <div v-if="filter_price_range.length">
                      <p class="filters__section__title"><span>Prezzo per notte</span></p>
                      <div v-for="(option,option_index) in filter_price_range" v-bind:key="_uid+'price_range'+option_index">
                        <vb-checkbox
                          @change="(selected) => {
                            update_filter_price_range({
                              ...option,
                              selected: selected,
                            })
                          }"
                          v-model="option.selected"
                          :vb_options="{
                            text: option.label + ` <span>${(hotels || []).filter(h => markup(h.room.rate.pricing.nightly).live_price <= option.min).length}</span>`,
                            value: option.selected,
                            type: 'light',
                          }"/>
                        </div>
                    </div>

                    <!-- salabam score -->
                    <div v-if="filter_salabam_scores.length">
                      <hr />
                      <p class="filters__section__title"><span>Valutazione della struttura</span></p>
                      <div v-for="(option,option_index) in filter_salabam_scores" v-bind:key="_uid+'salabam_scores'+option_index">
                        <vb-checkbox
                          @change="(selected) => {
                            update_filter_salabam_scores({
                              ...option,
                              selected: selected,
                            })
                          }"
                          v-model="option.selected"
                          :vb_options="{
                            text: option.label + ` <span>${option.amount}</span>`,
                            value: option.selected,
                            type: 'light',
                          }"/>
                        </div>
                    </div>

                    <!-- stars -->
                    <div v-if="filter_stars.length">
                      <hr />
                      <p class="filters__section__title"><span>Stelle della struttura</span></p>
                      <vb-checkbox
                        v-for="(option,option_index) in filter_stars" v-bind:key="_uid+'stars'+option_index"
                        @change="(selected) => {
                          update_filter_stars({
                            ...option,
                            selected: selected,
                          })
                        }"
                        v-model="option.selected"
                        :vb_options="{
                          text: option.text + ` <span>${option.amount}</span>`,
                          value: option.selected,
                          type: 'light',
                        }"/>
                    </div>

                    <!-- amenities -->
                    <div v-if="filter_amenities.length">
                      <hr />
                      <p class="filters__section__title">
                        <span class="d-flex align-items-center">
                          Caratteristiche della struttura
                          <vb-icon
                            :name="'info'"
                            :color="sass('gray-500')"
                            :size="16"
                            class="ml-1 cursor-pointer"
                            v-b-popover.hover.top="'I filtri indicati non rappresentano una valutazione da parte nostra sulla completezza o qualità dei servizi, in particolare per le caratteristiche di accessibilità per disabili, i servizi per bambini ecc.'"
                          />
                        </span>
                        <span class="filters__section__subtitle">
                          Alcuni servizi possono prevedere costi aggiuntivi
                          da pagare in loco.
                        </span>
                      </p>
                      <vb-checkbox
                        v-for="(option,option_index) in filter_amenities" v-bind:key="_uid+'amenities'+option_index"
                        @change="(selected) => {
                          update_filter_amenities({
                            ...option,
                            selected: selected,
                          })
                        }"
                        v-model="option.selected"
                        :vb_options="{
                          text: option.text + ` <span>${option.amount}</span>`,
                          value: option.selected,
                          type: 'light',
                        }"/>
                    </div>

                    <!-- rate amenities -->
                    <div v-if="filter_rate_amenities.length">
                      <hr />
                      <p class="filters__section__title">
                        <span class="d-flex align-items-center">
                          Servizi inclusi
                          <vb-icon
                            :name="'info'"
                            :color="sass('gray-500')"
                            :size="16"
                            class="ml-1 cursor-pointer"
                            v-b-popover.hover.top="'I filtri indicati non rappresentano una valutazione da parte nostra sulla completezza o qualità dei servizi, in particolare per le caratteristiche di accessibilità per disabili, i servizi per bambini ecc.'"
                          />
                        </span>
                        <span class="filters__section__subtitle">
                          Alcuni servizi possono prevedere costi aggiuntivi
                          da pagare in loco.
                        </span>
                      </p>
                      <vb-checkbox
                        v-for="(option,option_index) in filter_rate_amenities" v-bind:key="_uid+'rate_amenities'+option_index"
                        @change="(selected) => {
                          update_filter_rate_amenities({
                            ...option,
                            selected: selected,
                          })
                        }"
                        v-model="option.selected"
                        :vb_options="{
                          text: option.text + ` <span>${option.amount}</span>`,
                          value: option.selected,
                          type: 'light',
                        }"/>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </b-col>
          <b-col cols="7" v-if="filtering">
            <loader />
          </b-col>
          <b-col xs="12" xl="9" v-else>
            <div class="filters__btn-wrapper" v-if="!searching && !appending">
              <!-- title -->
              <div>
                <h3 class="filters__btn-title vb-heading vb-heading--h3" v-html="location.label" />
                <div class="filters__btn-resume">
                  <span vb-color-primary v-if="filtered.results">
                    <strong class="semibold">{{ filtered.results.length }} strutture mostrate</strong> <span v-if="total_properties">su {{ total_properties }} totali</span>
                  </span>
                </div>                
              </div>
              <!-- buttons -->
              <div class="filters__btn-content">
                <vb-dropdown
                  class="filters__btn-order mr-2 variant-white"
                  :vb_options="{
                    text: sort_values.filter(s => { return s.key == sort_by })[0].label,
                    size: 'sm',
                  }">
                  <b-dropdown-item v-for="(s,index) in sort_values.filter(s => { return s.sort })"
                    v-bind:key="_uid+'sort'+index" :active="sort_by == s.key || s.key == 'default_sorting' && sort_by == ''">
                    <div v-html="s.label"
                      @click="() => {
                        $store.commit('liveeps/sort_by', s.key)
                        filter_results()
                      }"
                    />
                  </b-dropdown-item>
                </vb-dropdown>
              </div>
            </div>
            <!--importante v-show per non rigenerare la mappa ogni volta-->
            <div class="results__map" v-show="map" :key="update_key_filter">
              <results-google-map
                :load_more="search"
                :loading="searching || appending || filtering"
                :map_markers="markers"
                :map_location="location"
                :map_info_window="{
                  offset: {x: 0, y: -40,}
                }"
                :map_style="{
                  styles: [/*snazzy maps json here */],
                }"
                @item-clicked="i => {
                  this.$store.commit('liveeps/update_selected_property', i.item)
                  this.$router.push('detail')          
                }"
              />
              <div v-for="res in filtered.results" v-bind:key="res.hotel_id" v-show="false">
                <custom-link
                  :ref="res.hotel_id"
                  :route_name="'detail'"
                  :css_class="'d-none'"
                  :as_default="get_config('guiSettings.openDetailNewTab', false)">
                  <template #content>
                    {{ res.hotel_id }}
                  </template>
                </custom-link>
              </div>
            </div>
            <div class="results__list" v-if="!map">
              <results-content-block :hotels="filtered.results" :searching="searching" :appending="appending" :toggle_map="toggle_map" />
              <div v-if="appending">
                <loader />
              </div>
              <div v-else-if="offset>-1" class="text-center mt-4">
                <vb-button
                  v-if="!searching"
                  @click="search()"
                  :vb_options="{
                    text: 'Mostra più risultati',
                    variant: 'outline-primary',
                    size: 'sm'
                  }"/>
              </div>
            </div>
          </b-col>
        </b-row>
      </section>
    </b-container>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { number, smaller, smallerEq, format } from 'mathjs'
import ResultsContentBlock from '@liveeps/components/views/content-blocks/results'
import GoogleMap from '@components/blocks/map'
import { service_handler } from '@services'
import { encode_parameters, decode_parameters, custom_event } from '@utilities'
import { get_amenities_flags, hotel_categories, review_score_values } from '@liveeps/resources'
import { map_markers_v3, markup } from '@liveeps/utilities'
import moment from 'moment'
import { amenities_rates, get_amenities_rates } from '../../resources/amenities_rates'

/*
FILTRI
  - page filters: agiscono sui risultati di ricerca già presenti (persistono sia nello state sia nel localstorage)
  - advanced filters: a livello di UI sono dei filtri, ma a livello logico triggerano nuove ricerche
RICERCA
  - se la ricerca avviene dal booking engine (a prescindere dalla vista in cui mi trovo) questo comporta un reset di tutti i filtri (page + advanced)
  - se la ricerca avviene tramite la modifica di un filtro avanzato (possibile solo dalla modal "Filtri avanzati" in /results) allora i filtri in page vengono preservati
  NB: il reset dei filtri viene gestito tramite un payload (opzionale) che viene aggiungo all'evento search, es:
   {
    reset_page_filters: true,
    discard_advanced_filters: true,
  }
*/
export default {
  name: 'results-view',

  components: {
    'results-content-block': ResultsContentBlock,
    'results-google-map': GoogleMap,
  },

  props: {
  },

  computed: {
    ...mapState({
      // global
      searching: state => state.searching,
      occupancy: state => state.occupancy,
      availability: state => state.availability,
      // liveeps
      checkin: state => state.liveeps.checkin,
      checkout: state => state.liveeps.checkout,
      last_search: state => state.liveeps.last_search,
      current_search: state => state.liveeps.current_search,
      trigger_search: state => state.liveeps.trigger_search,
      hotels: state => state.liveeps.hotels,
      sort_by: state => state.liveeps.sort_by,
      selected_solution: state => state.liveeps.selected_solution,
    }),
    location() {
      return decode_parameters(this.last_search).suggestion
    },

    filter_availability: {
      get() {return this.$store.state.liveeps.filter_availability},
      set(value) {this.$store.commit('liveeps/filter_availability', value)},
    },
    filter_refundable: {
      get() {return this.$store.state.liveeps.filter_refundable},
      set(value) {this.$store.commit('liveeps/filter_refundable', value)},
    },
    filter_stars: {
      get() {return this.$store.state.liveeps.filter_stars},
      set(value) {this.$store.commit('liveeps/filter_stars', value)},
    },
    filter_salabam_scores: {
      get() {return this.$store.state.liveeps.filter_salabam_scores},
      set(value) {this.$store.commit('liveeps/filter_salabam_scores', value)},
    },
    filter_amenities: {
      get() {return this.$store.state.liveeps.filter_amenities},
      set(value) {this.$store.commit('liveeps/filter_amenities', value)},
    },
    filter_rate_amenities: {
      get() {return this.$store.state.liveeps.filter_rate_amenities},
      set(value) {this.$store.commit('liveeps/filter_rate_amenities', value)},
    },
    filter_hotel_categories: {
      get() {return this.$store.state.liveeps.filter_hotel_categories},
      set(value) {this.$store.commit('liveeps/filter_hotel_categories', value)},
    },
    filter_price_range: {
      get() {return this.$store.state.liveeps.filter_price_range},
      set(value) {this.$store.commit('liveeps/filter_price_range', value)},
    },

    markers() {
      return map_markers_v3(
        this.filtered.results,
        this.get_availability().total,
        this.sass
      )
    },
    update_key_filter() {
      return this.filtered.results ? this.filtered.results.length : 0
    }
  },
  
  data() {
    get_amenities_flags, smallerEq, smaller
    
    return {
      show_filters: false,
      updating_price_range: false,
      total_properties: 0,
      offset: 0,
      filtering: false,
      filtered: {},
      advanced_filters: {},
      sort_values: [
        {
          label: 'Prezzo (dal più basso)',
          key: 'price-asc',
          sort: (a, b) => {
            return number(a.live_price) - number(b.live_price)
          },
        },
        {
          label: 'Prezzo (dal più alto)',
          key: 'price-desc',
          sort: (a, b) => {
            return number(b.live_price) - number(a.live_price)
          },
        },
        {
          label: 'Stelle',
          key: 'stars',
          sort: (a, b) => {
            return number(b.accommodations_details.stars) - number(a.accommodations_details.stars)
          }
        },
        {
          label: 'Valutazione',
          key: 'salabam_score',
          sort: (a, b) => {
            return number(b.accommodations_details.salabam_score) - number(a.accommodations_details.salabam_score)
          }
        },
        {
          label: 'Le nostre scelte',
          key: 'default_sorting',
          sort: (a, b) => {
            return number(a.default_sorting) - number(b.default_sorting)
          }
        },        
        {
          label: 'Ordina per',
          key: '',
          sort: false,     
        },
      ],
      map: false,
      appending: false,
      // ui update
      ui_key_filter_price_range: 0,
    }
  },

  created() {
    this.markup = markup
    this.$store.commit('liveeps/filter_salabam_scores', review_score_values.reverse())
    this.$store.commit('liveeps/filter_price_range', this.get_config('guiSettings.priceRanges', []))
    this.hotel_categories = hotel_categories
    this.amenities_rates = amenities_rates
    this.get_amenities_rates = get_amenities_rates
    this.discard_advanced_filters()
  },

  mounted() {

    // voglio lanciare una nuova ricerca (es. atterro da un'altra pagina e voglio una nuova ricerca)
    if (this.trigger_search) {
      this.$store.commit('searching', true)
      this.search()
    }

    // refresh di pagina (non ho gli hotels nello state né nel localstorage)
    else if (this.hotels.length == 0) {
      this.$store.commit('searching', true)
      this.search()
    }

    // ho gli hotels nello state e devo filtrarli (es. atterro da un'altra pagina ma NON voglio una nuova ricerca)
    else this.filter_results()
  },

  methods: {
    search(e = false) {

      const is_new_search = e.reset_search_results || this.trigger_search

      //this.$store.commit('searching', true)
      if (is_new_search) this.$store.commit('searching', true)                   // ridondante, lo lasciamo per sicurezza
      this.$store.commit('liveeps/trigger_search', false)      // serve altrimenti la vista va in loop sul search()

      if (e !==false) {
        if (e.reset_page_filters) this.reset_page_filters()
        if (e.reset_advanced_filters) this.reset_advanced_filters()
      }
      
      let timestamp_start = moment().valueOf()

      let salabam_categories = [],
        search_params = {
          checkin: this.checkin,
          checkout: this.checkout,
          suggestion: this.location,
          occupancy: this.occupancy,
        }

      // salabam_categories
      this.filter_hotel_categories.forEach(c => {
        salabam_categories.push(c)
      })
      
      if (salabam_categories.length > 0) search_params.salabam_categories = salabam_categories

      let current_search = encode_parameters(search_params)

      this.$store.commit('liveeps/current_search', current_search)
      
      if (is_new_search) {
        this.$store.commit('liveeps/hotels', [])
        this.offset = 0
        this.filtered = {}
      }

      else {
        this.appending = true
      }

      service_handler(
        'search',
        {
          ...search_params,
          offset: this.offset,
        },
      ).then(
        (success) => {
          const properties = success.data.data.properties
          this.total_properties = success.data.metadata.totalProperties
          this.offset = success.data.metadata.offset
          const hotels = [
            ...this.hotels,
            ...properties,
          ].map((h) => {
            return {
              ...h,
              id: h.property_id,
              accommodations_details: {
                image_url: h.thumbnail_url,
                salabam_score: h.ratings.salabam_score,
                stars: h.ratings.property ? h.ratings.property.rating || 0 : 0,
                coordinates: [h.location.coordinates.latitude, h.location.coordinates.longitude],
                name: h.name,
                salabam_category: h.salabam_category_id,
                hotel_description: h.short_description,
                address: h.location.address,
                zip: h.location.zip,
                city: h.location.city,
                province_state: h.location.province_state,
                country: h.location.country,
                amenities: h.amenities_flags,
              },
              refundable: {refundable: true},
            }
          })

          // delay controllato per evitare ricerche troppo veloci
          let gap = moment().valueOf() - timestamp_start,
            min_gap = 1500,
            delay = gap < min_gap ? (min_gap - gap) : 0

          setTimeout(() => {
            hotels.forEach((h,i) => {
              h.default_sorting = i
              h.live_price = markup(h.room.rate.pricing.total).live_price
            })
            this.$store.commit('liveeps/hotels', hotels)
            this.$store.commit('searching', false)
            const is_appending = this.appending
            this.appending = false
            this.filtered = this.filter_results(this.hotels, is_appending)

            custom_event({
              event: 'view_item_list',
              ecommerce: {
                currency: "EUR",
                items: this.parseGa4EcommerceItems(hotels),
                item_list_name: this.location.label,
              }
            })

          }, delay)
        },
        () => {
          this.$store.commit('searching', false)
        }
      )    
    },

    filter_results(hotels = this.hotels, is_appending = false) {
      
      this.filtering = true // UI only
      
      let filtered = {
        results: hotels,
      }

      // refundable
      filtered.refundable = filtered.results
      if (this.filter_refundable) {
        filtered.refundable = filtered.results.filter(h => {
          return h.room.rate.refundable_before !== null
        })
        filtered.results = filtered.refundable
      }

      // price range
      filtered.price_range = filtered.results
      this.get_price_range_options(filtered.results)
      let selected_price_range = this.filter_price_range.filter(f => {return f.selected})
      if (selected_price_range.length) {
        filtered.price_range = filtered.results.filter(h => { return markup(h.room.rate.pricing.nightly).live_price <= selected_price_range[0].min })
        filtered.results = filtered.price_range
      }
      
      // salabam score
      filtered.salabam_scores = filtered.results
      this.get_salabam_scores_options(filtered.results)
      let selected_salabam_score = this.filter_salabam_scores.filter(f => {return f.selected})
      if (selected_salabam_score.length) {
        let selected_salabam_score_value = selected_salabam_score[0].value
        filtered.salabam_scores = filtered.results.filter(h => {
          return h.accommodations_details.salabam_score >= selected_salabam_score_value
        })
        filtered.results = filtered.salabam_scores
      }
      
      // stars
      filtered.stars = filtered.results 
      this.get_stars_options(filtered.results)
      let selected_stars = this.filter_stars.map(f => {
        if (f.selected) return f.value
      }).filter(Boolean)  // il costruttore Boolean ritorna falsy e rimuove gli undefined
      if (selected_stars.length > 0) {
        filtered.stars = filtered.results.filter(h => {
          return selected_stars.includes(h.accommodations_details.stars)
        })
        filtered.results = filtered.stars
      }
      
      // amenities
      filtered.amenities = filtered.results 
      this.get_amenities_options(filtered.results)
      let selected_amenities = this.filter_amenities.map(f => {
        if (f.selected) return f.key
      }).filter(Boolean)  // il costruttore Boolean ritorna falsy e rimuove gli undefined
      if (selected_amenities.length > 0) {
        filtered.amenities = filtered.results.filter(h => {
          let property_amenities = []
          Object.keys(h.accommodations_details.amenities).forEach(key => {
            if (!/^has_/.test(key)) return
            let amenity_value = h.accommodations_details.amenities[key]
            if (amenity_value == true) property_amenities.push(key)
          })
          return selected_amenities.every(s => {
            return property_amenities.includes(s)
          })
        })
        filtered.results = filtered.amenities
      }
      
      // rate amenities
      filtered.rate_amenities = filtered.results
      this.get_rate_amenities_options(filtered.results)
      let selected_rate_amenities = this.filter_rate_amenities.map(f => {
        if (f.selected) return f.key
      }).filter(Boolean)  // il costruttore Boolean ritorna falsy e rimuove gli undefined
      if (selected_rate_amenities.length > 0) {
        filtered.rate_amenities = filtered.results.filter((h,index) => {
          const property_rate_amenities_labels = Object.keys(h.room.rate.amenities).map(p => {
            if (index==4) this.log(p)
            return this.get_rate_amenity_by_id(p, h.room.rate.amenities[p]).label
          })

          const selected_rate_amenities_labels = selected_rate_amenities.map(a => {
            return this.get_amenities_rates(a).label
          })

          /*
          if (index==4) {
            this.log('property_rate_amenities_labels', property_rate_amenities_labels, 'selected_rate_amenities_labels', selected_rate_amenities_labels)
            this.log('property_rate_amenities_labels', property_rate_amenities_labels, 'selected_rate_amenities_labels', selected_rate_amenities_labels)
          }*/
          const all_selected_rate_amenities_are_present = selected_rate_amenities_labels.every(label =>
            property_rate_amenities_labels.includes(label)
          )
          return all_selected_rate_amenities_are_present
        })
        filtered.results = filtered.rate_amenities
      }

      // sort results
      filtered.results = this.sort_items(filtered.results)
      this.filtered = filtered

      this.discard_advanced_filters()

      // finto timer solo per UI
      this.$nextTick(() => {
        setTimeout(() => {
          this.filtering = false
          //if(!is_appending)
          is_appending
          window.scrollTo(0,0)
        }, 500)
      })
      
      return filtered
    },

    active_filters() {
      let filters = {
        page_filters: [],
        advanced_filters: [],
      }
      
      // active page filters
      if (this.filter_refundable) {
        filters.page_filters.push({
          key: 'refundable',
          text: 'Solo rimborsabili',
          callback: this.update_filter_refundable,
        })
      }
      
      this.filter_salabam_scores.filter(f => { return f.selected }).forEach(f => {
        filters.page_filters.push({
          key: 'salabam_scores',
          filter: f,
          text: f.label,
          callback: this.update_filter_salabam_scores,
        })
      })
     
      this.filter_price_range.filter(f => { return f.selected }).forEach(f => {
        filters.page_filters.push({
          key: 'price_range',
          filter: f,
          text: f.label,
          callback: this.update_filter_price_range,
        })
      })
     
      this.filter_stars.filter(f => { return f.selected }).forEach(f => {
        filters.page_filters.push({
          key: 'stars',
          filter: f,
          text: f.text,
          callback: this.update_filter_stars,
        })
      })

      this.filter_amenities.filter(f => { return f.selected }).forEach(f => {
        filters.page_filters.push({
          key: 'amenities',
          filter: f,
          text: f.text,
          callback: this.update_filter_amenities,
        })
      })

      this.filter_rate_amenities.filter(f => { return f.selected }).forEach(f => {
        filters.page_filters.push({
          key: 'rate_amenities',
          filter: f,
          text: f.text,
          callback: this.update_filter_rate_amenities,
        })
      })

      // active advanced filters
      if (this.filter_hotel_categories) {
        this.filter_hotel_categories.forEach(f => {
          filters.advanced_filters.push({
            advanced_key: 'categories',
            key: 'categories'+f,
            text: Object.values(hotel_categories)[f-1].name,
            callback: () => {
              this.filter_hotel_categories = this.filter_hotel_categories.filter(h => {
                return h !== f
              })
              this.$store.commit('liveeps/hotels', [])
              this.offset = 0
              this.filtered = {}
              this.search()
            }
          })
        })
      }
      if (this.filter_price_range.min || this.filter_price_range.max) {
        filters.advanced_filters.push({
          advanced_key: 'price_range',
          key: 'price_range',
          text: '€' + (this.filter_price_range.min ? this.filter_price_range.min : this.min_price_bound) + ' - €' + (this.filter_price_range.max ? this.filter_price_range.max : this.max_price_bound),
          callback: () => {
            this.filter_price_range.min = 0
            this.filter_price_range.max = 0
          }
        })
      }

      return {
        ...filters,
        length: filters.advanced_filters.length + filters.page_filters.length,
      }
    },

    get_price_range_options(hotels) {
      if (hotels.length == 0) return
      let filter_price_range = this.get_config('guiSettings.priceRanges')
      filter_price_range = filter_price_range.map(f => {
        return {
          ...f,
          amount: hotels.filter(h => { return markup(h.room.rate.pricing.nightly).live_price <= f.min }).length,
        }
      })
      //this.$store.commit('liveeps/filter_price_range', filter_price_range)
      filter_price_range
    },

    get_filter_option_name(key, value) {
      switch (key) {
        case 'stars':
          if (value == -1) return "Nessuna stella"
          return value == 1 ? '1 Stella' : value + ' Stelle'
      }
      return value
    },

    get_salabam_scores_options(hotels, sort = 'value', key = 'salabam_scores', callback = null) {
      (callback, sort)
      if (hotels.length == 0) return
      let filter_salabam_scores = this.filter_salabam_scores
      filter_salabam_scores = filter_salabam_scores.map(f => {
        return {
          ...f,
          amount: hotels.filter(h => {

            return h.accommodations_details.salabam_score >= f.value
          }).length
        }
      })
      this.$store.commit('liveeps/filter_'+key, filter_salabam_scores)
    },
    
    get_stars_options(hotels, sort = 'value', key = 'stars', callback = null) {

      if (hotels.length == 0) return {}
      let filters = {}

      // preprocess hotels / add default values
      hotels.map(h => {
        if (h.accommodations_details.stars == '') h.accommodations_details.stars = '-1'
      })

      hotels.forEach(h => {
        let option_index, selected
        if (filters[key] == undefined) filters[key] = []
        option_index = filters[key].findIndex(s => { return s.value === h.accommodations_details[key] })
        if (option_index > -1) {
          let amount = filters[key][option_index].amount
          filters[key][option_index].amount = amount + 1
        }
        else {
          selected = false
          let item = this['filter_'+key].filter(f => { return h.accommodations_details[key] == f.value})
          if (item.length) selected = item[0].selected ? true : false
          filters[key].push({
            key: h.accommodations_details[key],
            text: this.get_filter_option_name(key, h.accommodations_details[key]),
            value: h.accommodations_details[key],
            amount: 1,
            selected: selected,
          })
        }
      })
      // callback
      if (callback) filters[key] = callback(filters[key])
      // sort
      if (sort) filters[key] = filters[key].sort((a,b) => { return b[sort] - a[sort] })
      this.$store.commit('liveeps/filter_'+key, filters[key])
    },

    get_amenities_options(hotels, sort = 'value', key = 'amenities', callback = null) {

      if (hotels.length == 0) return {}
      let filters = {}
      //let amenities_rate_options = this.get_config('guiSettings.amenities.rate')

      hotels.forEach(h => {
        let option_index, selected
        if (filters[key] == undefined) filters[key] = []
        else {
          Object.keys(h.accommodations_details.amenities).forEach(a => {
            if (!/^has_/.test(a)) return
            option_index = filters[key].findIndex(s => { return s.key === a })
            let value = number(h.accommodations_details.amenities[a])
            if (!value) return
            if (option_index > -1) {
              let amount = filters[key][option_index].amount
              filters[key][option_index].amount = amount + 1
            }
            else {
              selected = false
              let item = this['filter_'+key].filter(f => { return f.key == a })
              if (item.length) selected = item[0].selected ? true : false
              filters[key].push({
                key: a,
                text: get_amenities_flags(a).label,
                value: value,
                amount: 1,
                selected: selected,
              })
            }
          })
        }
      })
      // callback
      if (callback) filters[key] = callback(filters[key])
      // sort
      if (sort) filters[key] = filters[key].sort((a,b) => { return b[sort] - a[sort] })
      this.$store.commit('liveeps/filter_'+key, filters[key])
    },

    get_rate_amenities_options(hotels, sort = 'value', key = 'rate_amenities', callback = null) {
      if (hotels.length == 0) return {}
      let filters = {}

      hotels.forEach(h => {
        let option_index, selected
        if (filters[key] == undefined) filters[key] = []
        else {
          Object.keys(h.room.rate.amenities).forEach(a => {
          let value = get_amenities_rates(a).label
          if (!value) return
          option_index = filters[key].findIndex(s => { return s.value === value })
          if (option_index > -1) {
            let amount = filters[key][option_index].amount
            filters[key][option_index].amount = amount + 1
          }
          else {
            selected = false
            let item = this['filter_'+key].filter(f => { return f.key == a })
            if (item.length) selected = item[0].selected ? true : false
            filters[key].push({
              key: a,
              text: get_amenities_rates(a).label,
              value: value,
              amount: 1,
              selected: selected,
            })
          }
            /*
            let transcoded = this.get_rate_amenity_by_id(a, h.room.rate.amenities[a])
            option_index = filters[key].findIndex(s => { return s.key === transcoded.key })
            let value = transcoded.key
            if (!value) return
            if (option_index > -1) {
              let amount = filters[key][option_index].amount
              filters[key][option_index].amount = amount + 1
            }
            else {
              selected = false
              let item = this['filter_'+key].filter(f => { return f.key == a })
              if (item.length) selected = item[0].selected ? true : false
              filters[key].push({
                key: transcoded.key,
                text: transcoded.label,
                value: transcoded.key,
                amount: 1,
                selected: selected,
              })
            }*/
          })
        }
      })

      // callback
      if (callback) filters[key] = callback(filters[key])
      // sort
      if (sort) filters[key] = filters[key].sort((a,b) => { return b[sort] - a[sort] })
      this.$store.commit('liveeps/filter_'+key, filters[key])
    },
    
    update_filter_refundable(value) {
      this.$store.commit('liveeps/filter_refundable', value)
      this.filter_results()
    },

    update_filter_price_range(option) {
      let filter_key = 'filter_price_range',
        filter_store_key = 'liveeps/'+filter_key,
        filter = this[filter_key].map(f => {
        let selected = false
        if (f.min==option.min) selected = option.selected
        return {
          ...f,
          selected: selected
        }
      })
      this.$store.commit(filter_store_key, filter)
      this.update_ui_key(filter_key)
      this.filter_results()
    },

    update_filter_salabam_scores(option) {
      let filter_key = 'filter_salabam_scores',
        filter_store_key = 'liveeps/'+filter_key,
        filter = this[filter_key].map(f => {
        return {
          ...f,
          selected: f.value == option.value && option.selected
        }
      })
      this.$store.commit(filter_store_key, filter)
      this.filter_results(this.hotels/*, {salabam_scores: true}*/)
    },

    update_filter_stars(option) {
      let filter_key = 'filter_stars',
        filter_store_key = 'liveeps/'+filter_key,
        filter = this[filter_key].map(f => {
        return {
          ...f,
          selected: f.key == option.key ? option.selected : f.selected
        }
      })
      this.$store.commit(filter_store_key, filter)
      this.filter_results(this.hotels/*, {stars: true}*/)
    },
    
    update_filter_amenities(option) {
      let filter_key = 'filter_amenities',
        filter_store_key = 'liveeps/'+filter_key,
        filter = this[filter_key].map(f => {
        return {
          ...f,
          selected: f.key == option.key ? option.selected : f.selected
        }
      })
      this.$store.commit(filter_store_key, filter)
      this.filter_results(this.hotels, {amenities: true})
    },

    update_filter_rate_amenities(option) {
      let filter_key = 'filter_rate_amenities'
      let filter_store_key = 'liveeps/'+filter_key
      let actual_filters = [...this[filter_key]]
      let filter = actual_filters.map(f => {
        //this.log('FF', f, option)
        return {
          ...f,
          selected: f.key == option.key ? option.selected : f.selected
        }
      })
      this.$store.commit(filter_store_key, filter)
      this.filter_results(this.hotels/*, {rate_amenities: true}*/)
    },

    update_ui_key(key) {
      this[`ui_key_${key}`] = this[`ui_key_${key}`]+1
    },

    reset_page_filters() {
      this.$store.commit('liveeps/filter_refundable', false)
      this.$store.commit('liveeps/filter_amenities',this.filter_amenities.map(f => { return f.selected = false }))
      this.$store.commit('liveeps/filter_stars',this.filter_stars.map(f => { return f.selected = false }))
      this.$store.commit('liveeps/filter_price_range',this.filter_price_range.map(f => {
        return {
          ...f,
          selected: false 
        }}
      ))
      this.$store.commit('liveeps/filter_salabam_scores',this.filter_salabam_scores.map(f => {
        return {
          ...f,
          selected: false 
        }}
      ))
      this.$store.commit('liveeps/filter_availability',false)
      this.discard_advanced_filters()
      this.filter_results()
    },

    get_rate_amenity_by_id(id, name) {
      //this.log('CHECK get_rate_amenity_by_id', name, id)
      let rate_amenities_dictionary = this.get_config('guiSettings.amenities.rate')
      let amenity = rate_amenities_dictionary.filter(d => {
        return d.ids.includes(number(id))
      })[0]
      return {
        label: amenity ? amenity.label : name,
        key: amenity ? amenity.code : id,
      }
    },
    reset_advanced_filters() {
      this.$store.commit('liveeps/filter_hotel_categories', [])
    },
    reset_all_filters() {
      this.$nextTick(() => {
        this.reset_advanced_filters()
        this.reset_page_filters()
        this.submit_advanced_filters()
        //this.search()
      })
    },
    discard_advanced_filters() {
      this.advanced_filters = {
        filter_hotel_categories: [...this.filter_hotel_categories],
      }
    },
    submit_advanced_filters() {
      this.$store.commit('liveeps/filter_hotel_categories', this.advanced_filters.filter_hotel_categories)
      this.search({reset_search_results: true,})
    },    
    sort_items(items) {
      if (!items) return []
      let sort_item = this.sort_values.filter(s => { return s.key == this.sort_by })[0]
      if (sort_item.length == 0) return []
      if (!sort_item.sort) return items
      return items.sort(sort_item.sort)
    },
    toggle_filters() {
      document.body.classList.toggle('noscroll')
      this.show_filters = !this.show_filters
    },
    toggle_map() {
      this.map = !this.map
    },

    parseGa4EcommerceItems(results){
      const items = []

      results.forEach(hotel => {
        let hotel_name = hotel.name.split(',')[0],
            rate = hotel.room.rate

        items.push({
          item_id: hotel.id + "-" + rate.id,
          item_name: hotel_name,
          price: format(number(rate.pricing.total), {notation: 'fixed', precision: 2}),
        })
      })
      return items
    },
  },
}
</script>

<style lang="scss" scoped>

  .filters {

    &__sticky-wrapper {
      //position: sticky;
      align-self: flex-start;
      top: 0;
      min-height: 100vh;
      overflow-y: scroll;
      @include hide-scrollbar;
    }

    &__btn {

      &-wrapper {
        display: flex;
        align-items: self-end;
        justify-content: space-between;
        margin-bottom: 20px;
      }

      &-title {

        @include media-breakpoint-up(xl) {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          max-width: 500px;
          margin-bottom: 0;
        }

        @include media-breakpoint-up(xxl) {
          max-width: 650px;
        }
      }
    }

    &__head {
      margin-bottom: $grid-gutter-width/2;

      &-element {
        margin-bottom: 0;
        line-height: normal;
        display: flex;
        justify-content: space-between;
        align-items: center;
      }

      &-title {
        font-size: $font-size-lg;
        color: var(--primary);
        font-weight: $vb-font-weight-semibold;
        display: inline-block;
      }

      &-subtitle {
        color: var(--primary);
        font-size: $font-size-sm;
      }

      &-link {
        text-decoration: underline;
        font-size: $font-size-sm;
        cursor: pointer;
        color: var(--info);
        margin-left: 10px;
        * {
          white-space: nowrap;
        }
      }
    }

    &__credit {
    }

    &__refundable {
    }

    &__section__title {
      margin-bottom: $grid-gutter-width / 3;
      & span:first-child {
        font-weight: $vb-font-weight-semibold;
      }
    }

    &__section__subtitle {
      display: block;
      font-size: $font-size-sm;
      line-height: 1.2em;
      margin-top: 0.1em;
    }

    &__selected {
      padding-top: $grid-gutter-width/2;
      border-top: 1px solid $gray-300;
      margin-bottom: $grid-gutter-width/2;
    }

    &__panel {
      padding: $grid-gutter-width/2;
      border-bottom: 1px solid $gray-200;

      &:last-child {
        padding-bottom: $grid-gutter-width/3;
      }

      &-wrap {
        background: $white;
        border-radius: $border-radius-lg*2;
      }

      & .vb-check {
        margin-bottom: $grid-gutter-width/6;
      }
    }

    &__hotel-categories {
      display: flex;
      flex-direction: column;
      align-items: center;
      min-width: 100%;

      &__item {
        display: flex;
        align-items: center;
        min-width: 100%;
        text-align: center;
        border: 1px solid $gray-200;
        border-radius: $rounded-pill;
        padding: $grid-gutter-width/3 20px;
        transition: $transition-base;
        cursor: pointer;
        width: calc(50% - #{$grid-gutter-width/4});
        font-size: $font-size-md;
        line-height: 120%;
        margin-bottom: $grid-gutter-width/3;

        @include media-breakpoint-down(sm) {
          min-height: 55px;
        }

        &:last-child {
          margin-bottom: 5px;
        }

        &:hover, &.active {
          background-color: $selected;
          border-color: $gray-300;
        }
        &.active {
          background-color: $selected;
          border-color: $gray-300;
        }
      }

      &__icon {
        margin-right: 8px;
      }
    }

    &__price-range {
      display: block;

      &__item {
        width: 50%;
        display: inline-flex;
        align-items: center;

        &:first-child {
          &:after {
            content: "";
            width: 20px;
          }
        }

        .vee--errors {
          display: none !important;
        }
      }

      &__label {
        color: $gray-500;
        padding-right: 1rem;
      }

      @include media-breakpoint-up(sm) {

        &__item {
          width: auto;

          &:first-child {
            &:after {
              content: "";
              width: 60px;
              height: 1px;
              background-color: $gray-300;
              margin: 0 20px;
            }
          }
        }
      }
    }

    &__advanced-badge {
      border-radius: $border-radius-sm;
      background-color: $white;
      transition: $transition-base;
      font-weight: $font-weight-normal;
      color: $dark;
      &:hover, &:focus {
        background-color: $gray-200;
      }
    }

    &__counter {
      position: absolute;
      right:0;
      top: 0;
      transform: translateY(-50%);
      font-size: $font-size-sm;
      background: $dark;
      width: 16px;
      height: 16px;
      border-radius: $rounded-pill;
      color: $light !important;
      line-height: 120%;
      font-weight: $font-weight-bold;
    }

    @include media-breakpoint-down(md) {

      &__sticky-wrapper {
        position: static;
        flex: auto;
        max-width: 90vw;
        position: fixed;
        top:0;
        bottom: 0;
        height: 100vh;
        left: 10vw;
        z-index: 999; // la modal ha 1030, il pannello deve stare dietro
        padding: 0;
        transform: translateX(100%);
        transition: $transition-base;
        .toggle-map {
          display: none;
        }
        &.visible {
          transform: translateX(0);
        }
      }

      &__content-wrapper {
        padding: $grid-gutter-width/4 $grid-gutter-width/2;
        background-color: $white;
        position: relative;
        min-height: 100%;
      }

      &__btn-wrapper {
        flex-wrap: wrap;
        flex-direction: column;
        &>* {
          min-width: 100%;
        }
      }

      &__btn-content {
        min-width: 100%;
        display: flex;
        justify-content: center;
        margin-top: $grid-gutter-width/2;
      }

      &__btn-title {
        min-width: 100%;
        margin-bottom: 0;
        text-align: center;
      }

      &__btn-resume {
        text-align: center;
      }

      &__btn-order {
        margin-right: $grid-gutter-width/4;
      }

      &__btn-filter {
        display: none;
      }

      &__btn-filter-mobile {
      }

      &__btn-advanced-mobile {
        margin-top: 0;
        margin-bottom: $grid-gutter-width/4;
      }

      &__panel {
        padding-left: 0;
      }

      &__active-filters {
        display: none;
      }
    }
  }

  .results {

    &__map {
      max-height: 80vh;
      height: 320px;
      @include media-breakpoint-up(sm) {
        height: 400px;
      }
      @include media-breakpoint-up(md) {
        height: 600px;
      }
    }
  }

  body,html {
    &.noscroll {
      overflow: hidden;
    }
  }

  .section {
    &--booking-engine {
      margin: 0;
      position: relative;

      &:after {
        content: '';
        position: absolute;
        top: 0;
        bottom: 50%;
        left: 0;
        right: 0;
        background-color: $white;
      }
    }
  }

  ::v-deep {

    .variant-white {
      position: relative;

      .btn, &.btn {
        background-color: $white;
        color: $dark;
        border-color: transparent;
        * {
          color: $dark;
        }
        svg {
          --color: #{$dark};
        }

        &:after {
          filter: brightness(0);
        }

        &:hover, &:focus {
          border-color: transparent;
          background-color: $gray-200;
          color: $dark !important;
        }
      }

      .dropdown-menu {
        border: 1px solid $gray-200;
        font-size: $font-size-md;
        margin:0;
        padding: 0.75rem 0;
        a {
          color: inherit;
        }
        .active {
          color: var(--info);
        }
      }
    }

    .vb-check {
      $this: &;

      label {
        display: block;
        cursor: pointer;
      }

      input:checked {
        & + label .vb-check__title {
          span {
            color: var(--primary);
          }
        }
      }

      &__title {
        font-size: $font-size-md;

        span {
          position: absolute;
          right: 0;
        }
      }
    }

    .vb-switch {
      label {
        cursor: pointer;
      }
    }
  }

</style>

<style lang="scss">
  #map {
    //overflow: visible !important; // avoid info-window cut if overflows out from map container
  }
  .gm-style-iw {
    padding: 0 !important;
  }
  .gm-style-iw-d {
    overflow: visible !important;
  }
  button.gm-ui-hover-effect {
    width: 24px !important;
    height: 24px !important;
    background: $white !important;
    span {
      margin: 0 !important;
    }
  }
  .info-window {
    padding: 0.25rem 0.75rem 0.75rem 0.75rem;
    display: flex;
    flex-direction: column;
    font-size: $font-size-md;
    margin-top: -1rem;

    * {
      line-height: 120%;
    }

    & > *:not(:last-child) {
      margin-bottom: $grid-gutter-width/2;
    }

    &__image {
      width: 100%;
      height: 100px;
      overflow: hidden;
      border-radius: $border-radius-sm;
      img {
        max-width: 100%;
        width:100%;
        height: auto;
      }
    }

    &__text {
      display: flex;
      flex-direction: column;

      .top {
        display: flex;
        align-items: center;
        margin-bottom: $grid-gutter-width/4;
      }

      .left {
        flex: 1;
        display: flex;
        flex-direction: column;
      }

      .right {
        text-align: right;
        padding-left: 8px;
        font-size: $font-size-lg;
        font-weight: $vb-font-weight-semibold;
        color: var(--primary);
        display: flex;
        align-items: center;
      }

      .address {
        width:100%;
        font-size: $font-size-sm;
      }

      .name {
        width:100%;
        font-size: $font-size-md;
        font-weight: $vb-font-weight-semibold;
      }

      .ratings {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }

      .stars {
        display: flex;
        align-items: center;
        flex: 2;

        svg {
          width: 16px;
          height: auto;
          margin-right: 4px;
        }
      }

      .score {
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: $vb-font-weight-semibold;
        color: var(--info);
        text-align: center;
        flex: 1;
      }

      .copy {
        font-size: $font-size-sm;
        font-weight: $vb-font-weight-semibold;
        color: var(--secondary);
        margin-top: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;

        svg {
          width: 16px;
          height: auto;
          margin-right: 4px;
          transform: translateY(-1px);

          g {
            fill: var(--secondary);
          }
        }
      }
    }

    &__button {
      .btn {
        display: block;
        width: 100%;
      }
    }
  }
</style>